module.exports = "/_next/static/images/9e7292805a455fa3a0a8c8e69b15e7a0-young-people-walking@0.5x.jpg.webp";